import { encode as base64_encode } from "base-64";

import { postApi, baseURL } from "../components/Utility";

import { action, makeObservable, observable } from "mobx";
import config from "../config";

class WASLReportListStore {
  waslReportList = [];
  total = 0;
  loading = false;
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      waslReportList: observable,
      total: observable,
      loading: observable,
      loadData: action,
      exportExcel: action,
      exportpdf: action,
      sendExcelByEmail: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({
    offset,
    limit,
    companyId,
    vehicleId,
    fromDate,
    toDate,
    page,
  }) {
    this.loading = true;

    var postData = {
      companyId: companyId,
      vehicleId: vehicleId,
      fromDate: fromDate,
      toDate: toDate,
      offset: offset,
      limit: limit,
      page: page,
    };
    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=wasl&a=waslReport", "postData=" + base64Input);

     if (config.pythonReport === 1) {
      var response = await postApi.getClient("report").post("/miscellaneous_report/waslreport", postData);
    } else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi.getClient().post("index.php?c=wasl&a=waslReport", "postData="+base64Input);
    }

    this.waslReportList = response?.data?.data?.waslData;
    this.total = parseInt(response?.data?.data?.TotalCount);
    this.loading = false;
  }

  async exportExcel(getData) {
    console.log(getData, "getData");
    let lang = "english";

     if (config.pythonReport === 1) {
      console.log("This is the excel ")

      getData = { ...getData, language: "english" };
      
      try {
        await postApi.getClient("report").post("/miscellaneous_report/waslreport/download/excel", getData, {
          responseType: "blob",
        });
        this.pythonReportMessage = true;
      } catch (error) {
        this.pythonReportErrorMessage = true;
      }
      
    }
    else{

       window.location.href =
      baseURL +
      "index.php?c=wasl&a=exportwasllocationexcel&cid=" +
      getData.companyId +
      "&vid=" +
      getData.vehicleId +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList +
      "&userId=" +
      getData.userId +
      "&language=" +
      lang;

    }
   
  }

  async exportpdf(getData) {
    let lang = "english";
    if (config.pythonReport === 1) {
      getData = { ...getData, language: "english" };
      try {
          await postApi.getClient("report").post("/miscellaneous_report/waslreport/download/pdf", getData, {
            responseType: "blob",
          });
        this.pythonReportMessage = true;
      } catch (error) {
        this.pythonReportErrorMessage = true;
      }
    }
    else{

       window.location.href =
      baseURL +
      "index.php?c=wasl&a=exportwasllocationpdf&cid=" +
      getData.companyId +
      "&vid=" +
      getData.vehicleId +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList +
      "&userId=" +
      getData.userId +
      "&language=" +
      lang;

    }

   
  }

  // async exportcsv(getData) {
  //   let lang = "english";
  //   window.location.href =
  //     baseURL +
  //     "index.php?c=wasl&a=exportwasllocationcsv&cid=" +
  //     getData.companyId +
  //     "&vid=" +
  //     getData.vehicleId +
  //     "&fD=" +
  //     getData.fromDate +
  //     "&tD=" +
  //     getData.toDate +
  //     "&colList=" +
  //     getData.colList +
  //     "&userId=" +
  //     getData.userId +
  //     "&language=" +
  //     lang;
  // }
  // async exportxml(getData) {
  //   let lang = "english";
  //   window.location.href =
  //     baseURL +
  //     "index.php?c=wasl&a=exportwasllocationxml&cid=" +
  //     getData.companyId +
  //     "&vid=" +
  //     getData.vehicleId +
  //     "&fD=" +
  //     getData.fromDate +
  //     "&tD=" +
  //     getData.toDate +
  //     "&colList=" +
  //     getData.colList +
  //     "&userId=" +
  //     getData.userId +
  //     "&language=" +
  //     lang;
  // }

  async sendExcelByEmail(data) {
    var postData = data;
    console.log(postData);
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=vehicle&a=exportwasllocationexcel",
        "postData=" + base64Input
      );
    console.log(response);

    return response.data;
  }
}

export default WASLReportListStore;
